import clsx from "clsx";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { getOnboardingFarm } from "regen-api-ts-client";

import Check from "../../components/Check";
import { useRegenQuery } from "../../util/apiHooks";
import { ONBOARDING_STEPS } from "../../util/constants";
import { useGetMyUser } from "../../util/hooks";
import { VDiv } from "../Div";

interface OnboardingNavContentProps {
  currentStepIndex: number;
}

const OnboardingNavContent = ({
  currentStepIndex,
}: OnboardingNavContentProps) => {
  const { data: user } = useGetMyUser();
  const { data: onboardingFarm } = useRegenQuery(getOnboardingFarm, {
    throwOnError: false,
  });

  const isOnboardingComplete = useMemo(() => {
    return user?.emailVerified && onboardingFarm?.yearsOperated != null;
  }, [user, onboardingFarm]);

  const getStepLabelClasses = (stepLabelIdx: number) => {
    return clsx({
      "lg:block text-sm text-primary": true,
      "font-bold": stepLabelIdx === currentStepIndex && !isOnboardingComplete,
    });
  };

  return (
    <VDiv className="gap-2">
      {ONBOARDING_STEPS.map((step, idx) => {
        const isStepCompleted = currentStepIndex > idx || isOnboardingComplete;
        const isCurrentStep = currentStepIndex === idx;
        if (!step.label) {
          return;
        }
        const tabContent = (
          <>
            <div className="mr-2 lg:mr-4">
              <Check
                showCheck={isStepCompleted}
                showActive={isCurrentStep || isStepCompleted}
              />
            </div>
            <span className={getStepLabelClasses(idx)}>{step.label}</span>
          </>
        );
        return isStepCompleted ? (
          <Link
            to={`/onboarding/${step.path}`}
            key={step.label}
            className="flex items-center lg:mb-2"
          >
            {tabContent}
          </Link>
        ) : (
          <div key={step.label} className="flex items-center lg:mb-2">
            {tabContent}
          </div>
        );
      })}
    </VDiv>
  );
};

export default OnboardingNavContent;
